import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.response.use(r => r, async error => {
  const cfg = error.config;
  if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/")) {
    cfg._retry = true;
    try { await client.post("/auth/refresh"); return client(cfg); } catch { return Promise.reject(error); }
  }
  return Promise.reject(error);
});

const FIELD_LABELS = { order_id: "ID pesanan", buyer_name: "nama pembeli", buyer_email: "email pembeli", quantity: "jumlah", unit_price: "harga", product_id: "produk", sku: "SKU", name: "nama", category: "kategori", price: "harga", email: "email", password: "kata sandi", store_name: "nama toko", recipient_email: "email penerima" };
const ERROR_LABELS = { string_too_short: "terlalu pendek", string_too_long: "terlalu panjang", value_error: "formatnya tidak valid", missing: "wajib diisi", greater_than_equal: "terlalu kecil", less_than_equal: "terlalu besar", int_parsing: "harus angka" };

export function formatApiError(err, fallback = "Terjadi kesalahan. Coba lagi.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Data tidak valid: " + detail.map(e => `${FIELD_LABELS[e?.loc?.at(-1)] || e?.loc?.at(-1) || "isian"} ${ERROR_LABELS[e?.type] || "tidak sesuai"}`).join("; ");
  return fallback;
}

const STATUS_LABELS = { waiting: "Menunggu", processing: "Diproses", success: "Terkirim", failed: "Gagal", needs_review: "Perlu Penanganan", pending: "Menunggu", verified: "Terverifikasi", active: "Aktif", rejected: "Ditolak", suspended: "Dinonaktifkan" };
export const label = v => STATUS_LABELS[v] || v;

export const ROLE_LABELS = { admin: "Pemilik platform", seller: "Penjual", buyer: "Pembeli" };
export const isStoreRole = user => user && (user.role === "admin" || user.role === "seller");
